import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'

export const getGameRosters = async (gameId) => {
  const { data } = await req(ENDPOINTS.GAMES.GET_GAME_ROSTERS(gameId))
  return data
}

// One team's roster for a game: `{ players, team_officials, ... }`.
export const getGameRoster = async (gameId, rosterId) => {
  const { data } = await req(ENDPOINTS.GAMES.GET_GAME_ROSTER(gameId, rosterId))
  return data
}
